import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template"]
  static values = { reopen: Boolean }

  connect() {
    this.nextIndex = this.rowsTarget.children.length
    if (this.reopenValue) this.element.closest("dialog").showModal()
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", this.nextIndex++)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-container-row]").remove()
  }
}
